module.exports = __webpack_public_path__ + "static/media/upload_issues.c05b436f.svg";